import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import { Icons } from "../../config/MuiIcons.config";
import Menu from "@mui/material/Menu";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import "./ProfileMenu.style.css";
import { extractFirstName } from "../../common/CommonFunctions";
import { useMediaQuery } from "@mui/material";
import { firebaseLogOut } from "../../services/authServices/auth.services";
import { AppTheme } from "../../theme/App.theme";
import { getUserRoleAndScreens } from "../../services/authServices/auth.services";
import { getRelativeRoleName } from "../../config/Roles.config";

const ProfileMenu = () => {
  const { role } = getUserRoleAndScreens();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const { SetAppState } = useContext(AppGlobalContext);

  const isMobileMid = useMediaQuery("(max-width:500px)");
  const isSmallDevice = useMediaQuery("(max-width:820px)");

  const isZingworksAdmin =
    role && role.toLowerCase() === "zingworks" ? true : false;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    role: "",
    companyName: "",
    timezoneInfo: "",
  });

  useEffect(() => {
    const authUser = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
    );
    if (authUser) {
      const profileName =
        authUser?.displayName || extractFirstName(authUser?.email);
      setUserDetails({
        name: profileName,
        email: authUser?.email,
        role: getRelativeRoleName(authUser?.appRoleName?.toLowerCase()),
        companyName: authUser?.companyName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateUser = (path) => {
    navigate(path);
    setAnchorEl(null);
  };

  const handleUserLogout = () => {
    firebaseLogOut();
    SetAppState({
      isAuthUser: false,
      loggedInUserRole: false,
      responsibilities: null,
      authUserDetails: {},
    });
    localStorage.clear();
    navigate("/", {
      replace: true,
    });
    window.history.pushState(null, "", "/")
  };

  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        <div
          className="d-flex align-items-center ms-auto"
          style={{ cursor: "pointer" }}
          onClick={(e) => handleMenu(e)}
        >
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
            className="me-1"
            style={{ color: AppTheme.PRIMARY_COLOR, fontSize: "35px" }}
          >
            <Icons.UserProfileIcon fontSize="inherit" />
          </IconButton>
          <div
            style={{
              display: isMobileMid ? "none" : "inline-block",
            }}
          >
            <Typography
              className="text-capitalize inter-regular-400"
              style={{ fontSize: "14px" }}
            >
              {userDetails.name}
            </Typography>
            <Typography
              className="inter-light-300"
              style={{ fontSize: "11px" }}
            >
              {userDetails.role}{" "}
              {!isZingworksAdmin ? `(${userDetails.companyName})` : ""}
            </Typography>
          </div>
          <Icons.DownArrowAngleIcon
            className="mx-2"
            color="action"
            style={{ display: isMobileMid ? "none" : "initial" }}
          />
        </div>
      </div>

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{
          paper: {
            className: "menu-propover-class",
            sx: {
              "& .MuiMenu-list": {
                padding: 0,
              },
            },
          },
        }}
      >
        <div className="profile-main-div my-0">
          {/* <div className="profile-icon-container">
            <div
              className="profile-icon-circle"
              onClick={() => {
                navigateUser("/profile");
              }}
            >
              <span className="inter-medium-500 profile-initial-text">
                {userDetails.name?.charAt(0)?.toUpperCase()}
              </span>
              <div
                className="profile-edit-icon"
                onClick={() => {
                  navigateUser("/profile");
                }}
              >
                <Icons.EditIcon className="edit-pencil" />
              </div>
            </div>
          </div> */}
          <div
            className="account-info-container"
            // onClick={() => {
            //   navigateUser("/profile");
            // }}
          >
            <div className="selected-account-wrapper py-2">
              <div className="account ps-3">
                <div className="selected-account-img">
                  <Typography className="inter-medium-500" variant="h6">
                    {userDetails.name?.charAt(0)?.toUpperCase()}
                  </Typography>
                </div>
                <div className="profile-info w-75">
                  <Typography
                    className="inter-medium-500 text-light text-capitalize"
                    variant="subtitle1"
                    style={{ fontSize: "15px" }}
                  >
                    {userDetails.name}
                  </Typography>
                  <Typography
                    className="inter-regular-400 text-light"
                    variant="caption"
                    noWrap
                  >
                    {userDetails.email}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
          />
          <div className="logout-section-container" onClick={() => navigateUser("/profile")}>
            <div className="account-logout-wrapper py-2">
              <div className="logout ps-3">
                <div>
                  <Icons.SettingsIcon
                    sx={{ color: "GrayText", mr: 1 }}
                  />
                </div>
                <div className="logout-text">
                  <Typography className="inter-regular-400" variant="subtitle1">
                    Manage Profile
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
          />
          <div className="logout-section-container" onClick={handleUserLogout}>
            <div className="account-logout-wrapper py-2">
              <div className="logout ps-3">
                <div>
                  <Icons.PowerSettingsNewIcon
                    sx={{ color: "GrayText", mr: 1 }}
                  />
                </div>
                <div className="logout-text">
                  <Typography className="inter-regular-400" variant="subtitle1">
                    Log Out
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Menu>
    </React.Fragment>
  );
};

export default ProfileMenu;
